export default __webpack_public_path__ + "static/media/google_play.2de8c650.svg";